<template>
  <div :class="`my-5 ${isMobile ? 'w-100' : 'w-50'}`">
    <div v-if="userList">
      <div class="box-white d-flex flex-column" v-if="userInfo">
        <div class="mt-2 vertical-center d-flex justify-content-between">
          <img class="circle-image-80" :src="userInfo.photoUrl ? userInfo.photoUrl : assets.profile" />
          <span :class="`${isMobile ? '' : 'col-sm-8'} font-20 font-bold`">{{ userInfo.userName }}</span>
        </div>
        <div class="mt-5 d-flex justify-content-between">
          <span class="font-12 alpha-07">Email</span>
          <span :class="`${isMobile ? '' : 'col-sm-8'} font-15 font-bold`">{{ userInfo.email }}</span>
        </div>
        <div class="mt-5 d-flex justify-content-between">
          <span class="font-12 alpha-07">Phone</span>
          <span :class="`${isMobile ? '' : 'col-sm-8'} font-15 font-bold`">{{ userInfo.phone }}</span>
        </div>
        <div class="mt-5 d-flex justify-content-between">
          <span class="font-12 alpha-07">Gender</span>
          <span :class="`${isMobile ? '' : 'col-sm-8'} font-15 font-bold`">{{ getGender(userInfo.gender) }}</span>
        </div>
        <div class="mt-5 d-flex justify-content-between">
          <span class="font-12 alpha-07">Birthday</span>
          <span :class="`${isMobile ? '' : 'col-sm-8'} font-15 font-bold`">{{ userInfo.birthday }}</span>
        </div>
        <div class="mt-8 d-flex justify-content-between">
          <span class="font-12 alpha-07">Created At</span>
          <span :class="`${isMobile ? '' : 'col-sm-8'} font-12`">{{ getDateStringFromTimestamp(userInfo.createdAt) }}</span>
        </div>
        <div class="mt-5 d-flex justify-content-between" v-if="userInfo.deletedAt">
          <span class="font-12 alpha-07 color-red">Deleted At</span>
          <span :class="`${isMobile ? '' : 'col-sm-8'} font-12 color-red`">{{ getDateStringFromTimestamp(userInfo.deletedAt) }}</span>
        </div>
        <span>&nbsp;</span>
      </div>
      <div class="my-5 box-white d-flex flex-column" v-if="(userInfo && userInfo.organizerInfo)">
        <span class="mt-5 font-15 font-bold color-red" v-if="(userInfo.userType === -1)">Unapproved Organizer</span>
        <div class="mt-5 d-flex justify-content-between">
          <span class="font-12 alpha-07">Organizer Name</span>
          <span :class="`${isMobile ? '' : 'col-sm-8'} font-15 font-bold`">{{ userInfo.organizerInfo.name }}</span>
        </div>
        <div class="mt-5 d-flex justify-content-between">
          <span class="font-12 alpha-07">Tax Code</span>
          <span :class="`${isMobile ? '' : 'col-sm-8'} font-15 font-bold`">{{ userInfo.organizerInfo.taxCode }}</span>
        </div>
        <div class="mt-5 d-flex justify-content-between">
          <span class="font-12 alpha-07">Address</span>
          <span :class="`${isMobile ? '' : 'col-sm-8'} font-15 font-bold`">{{ userInfo.organizerInfo.address }}</span>
        </div>
        <div class="mt-5 d-flex justify-content-between">
          <span class="font-12 alpha-07">Organizer Phone</span>
          <span :class="`${isMobile ? '' : 'col-sm-8'} font-15 font-bold`">{{ userInfo.organizerInfo.phone }}</span>
        </div>
        <div class="mt-5 d-flex justify-content-between">
          <span class="font-12 alpha-07">Account Holder Name</span>
          <span :class="`${isMobile ? '' : 'col-sm-8'} font-15 font-bold`">{{ userInfo.organizerInfo.cardName }}</span>
        </div>
        <div class="mt-5 d-flex justify-content-between">
          <span class="font-12 alpha-07">IBAN-Nummer</span>
          <span :class="`${isMobile ? '' : 'col-sm-8'} font-15 font-bold`">{{ userInfo.organizerInfo.cardNumber }}</span>
        </div>
        <div class="mt-5 d-flex justify-content-between">
          <span class="font-12 alpha-07">BIC</span>
          <span :class="`${isMobile ? '' : 'col-sm-8'} font-15 font-bold`">{{ userInfo.organizerInfo.cardBIC }}</span>
        </div>
        <div class="my-5 d-flex justify-content-between">
          <span class="font-12 alpha-07">Description</span>
          <span :class="`${isMobile ? '' : 'col-sm-8'} font-15 font-bold`">{{ userInfo.organizerInfo.description }}</span>
        </div>
      </div>
      <div class="mt-5 d-flex justify-content-end" v-if="(userInfo.userType === -1)">
        <v-btn class="button-normal" @click="setUserTypeTask(1)">
          <span>Approve</span>
        </v-btn>
        <v-btn class="ml-10 button-normal" @click="setUserTypeTask(0)">
          <span>Decline</span>
        </v-btn>
      </div>
      <div class="py-40 center" v-if="!userInfo">
        <span class="font-20 alpha-07">No user found!</span>
      </div>
    </div>
    <div class="py-40 center" v-else>
      <p>Please wait ...</p>
      <b-spinner type="grow"></b-spinner>
    </div>
  </div>
</template>


<script>
import { httpsCallable } from 'firebase/functions';
import { functions } from '../../../main';
import { getDateStringFromTimestamp, showLoading } from '../../../functions';

import profile from '@/assets/image/profile.jpg';

export default {
  name: 'UserDetail',
  computed: {
    isMobile() {
      return this.$store.state.isMobile;
    },
    userList() {
      return this.$store.state.userList;
    },
    userInfo() {
      return this.userList ? this.userList.find(element => element.userId === this.$route.params.userId) : null;
    }
  },
  data() {
    return {
      assets: {
        profile
      }
    }
  },
  methods: {
    getDateStringFromTimestamp,
    getGender(gender) {
      switch (gender) {
        case 1: return 'Male';
        case 2: return 'Female';
        default: return 'Undefined';
      }
    },
    setUserTypeTask(userType) {
      if (!confirm(`Are you sure you want to approve this user as ${userType === 1 ? 'Organizer' : 'Single User'}?`)) {
        return;
      }
      const params = {
        functionName: 'setUserType',
        userId: this.$route.params.userId,
        userType: userType
      };
      const loader = showLoading(this, 1);
      const func = httpsCallable(functions, this.ADMIN_FUNCTION);
      func(JSON.stringify(params)).then(response => {
        loader.hide();
        if (response.data === this.RESULT_SUCCESS) {
          this.$toast.success('Approved successfully.');
        } else {
          this.$toast.error(response.data);
        }
      }).catch(error => {
        loader.hide();
        this.$toast.error(error.code + ', ' + error.message);
      });
    }
  }
};
</script>